/* SwitchToOsPlanComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const SwitchToOsPlanRenderer = require("./SwitchToOsPlanRenderer");

/**
 * This is a hack view component to switch view to Config Audit
 */
class SwitchToOsPlanComponent extends EventEmitter {
    constructor(logger, gameEditor, solutionsManager, steveIo, EditorSectionMgr) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._solutionsManager = solutionsManager;
        this._fileFactory = steveIo.fileFactory;
        this._editorComponent = EditorSectionMgr;
        this._renderer = new SwitchToOsPlanRenderer(this);
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    closeAllEditors() {
        this._editorComponent._editorLayout.closeAllEditors();
    }

    shutdown() {
        return this._renderer.shutdown().then(() => {
            this._logger = undefined;
            this._fileFactory = undefined;
            this._gameEditor = undefined;
            this._editorComponent = undefined;
            this._renderer = undefined;
            return Promise.resolve();
        });
    }
}
module.exports = SwitchToOsPlanComponent;

SwitchToOsPlanComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.solutionsManager",
    "$teve.io",
    "EditorSection.EditorSectionMgr",
];

SwitchToOsPlanComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "osmanager.os_plan",
    title: "OS Plan Explorer",
    shown: true,
    order: 3,
};
